module.exports = __webpack_public_path__ + "img/arrow_smart.cba457e7.svg";